import { render, staticRenderFns } from "./alading.vue?vue&type=template&id=2505a66c&"
import script from "./alading.vue?vue&type=script&lang=js&"
export * from "./alading.vue?vue&type=script&lang=js&"
import style0 from "./alading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports